export default "__VITE_ASSET__Cd1Cv1NY__"